//TODO: Remove exponea implementation of upselling recommendation, when it is clear there will be no further usage

import * as React from 'react';

import { useQuery } from '@apollo/client';

import { AB_TEST } from '@abTests';
import { useAbTest } from '@containers/ProductDetailContainer/ProductDetail/hooks/useAbTest/useAbTest';
import { useTrackingContext } from '@context/tracking/TrackingContext';
import { isAbTestEnabled } from '@helpers/utils';

import {
  upsellingProducts,
  upsellingProductsVariables,
} from './queries/__generated__/upsellingProducts';
import databreakersUpsellingQuery from './queries/databreakersUpsellingQuery.graphql';
import { RelatedWrapper } from './styled';
import { UpsellingList } from './UpsellingList';
import { notifyCypressUpsellingDisabled, trackUpsellingOpen } from './utils';

interface IUpsellingProductsProps {
  productCode: string;
  isDatabreakersActive?: boolean;
}

export const UpsellingProducts: React.FC<IUpsellingProductsProps> = ({
  productCode,
  isDatabreakersActive = false,
}) => {
  const { getTimeFromInit } = useTrackingContext();
  const abTestValue = useAbTest();
  const isEnabledAbTestForDatabreakers = isAbTestEnabled(
    abTestValue,
    [AB_TEST.SHOW_DATABREAKERS_PRODUCTS, AB_TEST.SHOW_DATABREAKERS_PRODUCTS_2],
    '1'
  );

  const shouldRenderDatabreakers =
    isEnabledAbTestForDatabreakers ||
    (isDatabreakersActive &&
      !(
        abTestValue?.includes(AB_TEST.SHOW_DATABREAKERS_PRODUCTS) ||
        abTestValue?.includes(AB_TEST.SHOW_DATABREAKERS_PRODUCTS_2)
      ));

  //Databreakers recommendations
  const { data: databreakersResponse } = useQuery<
    upsellingProducts,
    upsellingProductsVariables
  >(databreakersUpsellingQuery, {
    skip: !shouldRenderDatabreakers,
    variables: { productCode },
  });

  React.useEffect(() => {
    trackUpsellingOpen({ timing: getTimeFromInit() });
  }, [getTimeFromInit]);

  const isDatabreakersResponseEmpty =
    !databreakersResponse ||
    !databreakersResponse.getUpsellingProducts ||
    databreakersResponse.getUpsellingProducts.length === 0;

  if (isDatabreakersResponseEmpty) {
    notifyCypressUpsellingDisabled(shouldRenderDatabreakers);
    return null;
  }

  return (
    <RelatedWrapper data-testid={'upselling-wrapper'}>
      <UpsellingList
        databreakersProductIds={
          isDatabreakersResponseEmpty
            ? []
            : databreakersResponse.getUpsellingProducts
        }
      />
    </RelatedWrapper>
  );
};
